import { ChangePasswordForm } from "@uzverse/ui";
import { useCommonT, useErrorText } from "../components/common.js";
import { AuthHeader } from "../components/Layout.js";
import { useSession } from "../state/session.js";

/** Shown instead of the app when the password was set by someone else (first sign-in). */
export function ChangePasswordPage() {
  const tc = useCommonT();
  const errorText = useErrorText();
  const { services, refreshUser, signOut } = useSession();
  return (
    <main className="auth">
      <div className="auth-card card">
        <AuthHeader />
        <h1>{tc("ui.password.title")}</h1>
        <ChangePasswordForm
          t={tc}
          forced
          submit={(current, next) => services.api.changePassword(current, next)}
          onDone={() => void refreshUser()}
          onSignOut={() => void signOut()}
          errorText={errorText}
        />
      </div>
    </main>
  );
}
